"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = renderTemplate;
var _get2 = _interopRequireDefault(require("lodash/get"));
var HANDLEBARS_NESTED_PROPERTY_REGEX = /{{ *([A-z][A-z0-9.]+)* *}}/gm;

/**
 * Given a handlebars-style htmlTemplate, reduxState, and args, renderTemplate() will return the substituted string.
 * Note: renderTemplate() only supports {{object.subobject.proprety}}, not any other handlebars features.
 * When doing its replacements, it short-circuits if an object or property is not found,
 * and replaces any undefined values with an empty string.
 *
 * @export
 * @param {String} htmlTemplate The template, which may include handlebars-style {{object.prop}}
 * @param {Object} context The context we should use to populate the template
 */
function renderTemplate(htmlTemplate, context) {
  var replacedTemplate = (' ' + htmlTemplate).slice(1); // Make a copy
  var match;
  while ((match = HANDLEBARS_NESTED_PROPERTY_REGEX.exec(htmlTemplate)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (match.index === HANDLEBARS_NESTED_PROPERTY_REGEX.lastIndex) {
      HANDLEBARS_NESTED_PROPERTY_REGEX.lastIndex++;
    }

    // Need to replace match[0] (i.e. "{{aguments.0}}") with obj[match[1]] ("arguments.0")
    replacedTemplate = replacedTemplate.replace(match[0], (0, _get2["default"])(context, match[1], ''));
  }
  return replacedTemplate;
}